<template>
  <div v-if="visible" class="dialog-overlay" :class="{ 'no-overlay': !showOverlay }" @click.self="onOverlayClick">
    <div class="dialog-box">
      <div class="dialog-header">{{ title }}</div>
      <div class="dialog-content">
        <slot></slot> <!-- 使用插槽显示内容 -->
      </div>
      <div class="dialog-footer">
        <button v-if="showCancelButton" class="dialog-btn cancel" :disabled="cancelDisabled" @click="cancel">{{ cancelText }}</button>
        <button v-if="showConfirmButton" class="dialog-btn confirm" :disabled="confirmDisabled" @click="confirm">{{ confirmText }}</button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  visible: Boolean,
  title: String,
  showOverlay: {
    type: Boolean,
    default: true
  },
  showCancelButton: {
    type: Boolean,
    default: true
  },
  showConfirmButton: {
    type: Boolean,
    default: true
  },
  cancelText: {
    type: String,
    default: '取 消'
  },
  confirmText: {
    type: String,
    default: '确 定'
  },
  cancelDisabled: {
    type: Boolean,
    default: false
  },
  confirmDisabled: {
    type: Boolean,
    default: false
  }
});
const emits = defineEmits(['update:visible', 'confirm', 'cancel']);

const close = () => emits('update:visible', false);
const confirm = () => emits('confirm');
const cancel = () => emits('cancel');

const onOverlayClick = () => {
  if (!props.showOverlay) return;
  close();
};
</script>

<style scoped>
.dialog-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
  animation: fadeIn 0.2s ease-out;
}

.dialog-overlay.no-overlay {
  background: transparent;
  backdrop-filter: none;
  pointer-events: none;
}

.dialog-overlay.no-overlay .dialog-box {
  pointer-events: auto;
}

.dialog-box {
  width: 80%;
background: var(--D3-bg-color-container, #f5f7fb);
  /* border: 1px solid var(--D3-border-color); */
    /* box-shadow: 0 10px 20px -12px rgba(0, 0, 0, 0.25); */
  box-shadow: 0 30px 50px -12px var(--D3-border-color);
  border-radius: 12px;
  /* overflow: hidden; */
  /* animation: slideUp 0.25s ease-out; */
}

.dialog-header {
  padding: 20px 18px 0;
  font-size: 1.5rem;
  font-weight: 400;
  text-align: center;
  color: var(--card-title-color);
}

.dialog-content {
  padding: 16px 30px;
  color: var(--color-text);
  font-size: 25px;
  line-height: 1.5;
  text-align: left;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  padding: 10px 18px 16px;
  gap: 15px;
}

.dialog-btn {

  flex: 1;
  /* padding: 8px 0; */
  border: none;
  border-radius: 10px;
  height: 2.2rem;
}

.dialog-btn.cancel {
  background: #f2f2f2;
  color: #333; 
  font-size: 1rem;
}

.dialog-btn.confirm {
  background: #007aff;
  color: white;
   font-size: 1rem;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from { transform: translateY(30px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}
</style>
